import {Mid} from '@mid/sdk'
import {calculateAndSetExpTime} from '@mid/sdk/dist/lib/timer'

import {UserContextType} from '../../context/UserContext'
import {CALLBACK_PATH, LOGOUT_PATH} from '../../utils/constants'
import {savePath} from '../login-callback/LoginCallback'

const mid = new Mid({
  loginInfo: {
    appId: window.czConfig.OIDC_APP_ID,
    oidcConfigUrl: window.czConfig.OIDC_CONFIG_URL,
    authDriver: 'mid'
  },
  redirectUrl: `${window.location.origin}${CALLBACK_PATH}`,
  logoutRedirectUrl: `${window.location.origin}${LOGOUT_PATH}`
})

export const login = async () => {
  const isAuthed = await mid.isAuthed()
  if (isAuthed) {
    return
  }
  await mid.login()
}

export const accessToken = () => mid.accessToken()

export const refresh = async () => {
  await mid.refresh()

  const userInfo = getUserInfo()
  calculateAndSetExpTime(mid.core, userInfo)
}

export const getUserInfo = () => mid.accessInfo() as UserContextType

const midLogout = mid.logout.bind(mid)

mid.logout = () => {
  savePath()
  return midLogout()
}

const midCoreLogout = mid.core.logout.bind(mid.core)

mid.core.logout = () => {
  savePath()
  return midCoreLogout()
}
